import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    list: [],
    links: {},
    meta: {},
    form: {
      id: null,
      action_type: null,
      table_name: null,
      record_id: null,
      old_value: null,
      new_value: null,
      requested_by: null,
      bank: null,
      requested_at: null,
      approved_by: null,
      approved_at: null,
      status: null,
    },
  },
  mutations: {
    SET_AUDIT_LOG: (state, data) => Object.assign(state.form, data),
    STORE_AUDIT_LOGS: (state, data) => state.list.unshift(data),
    SET_AUDIT_LOGS: (state, data) => {
      state.list = data.data;
      state.links = data.links;
      state.meta = data.meta;
    },
    UPDATE_AUDIT_LOGS: (state, data) => {
      state.list = state.list.filter((item) => item.id !== data.id);
      state.list.unshift(data);
    },
  },
  getters: {
    auditLogs: (state) => {
      let auditLogs = new FormData();

      return auditLogs;
    },
  },
  actions: {
    async get({ commit }, { page, phone, name, bank_id }) {
      const { payload } = await $http.get(
        `admin/audit-logs?page=${page}${phone ? `&phone=${phone}` : ""}${
          name ? `&name=${name}` : ""
        }${bank_id ? `&bank_id=${bank_id}` : ""}`
      );
      commit("SET_AUDIT_LOGS", payload);
    },
    async show({ commit }, id) {
      const { payload } = await $http.get(`admin/audit-logs/${id}`);
      commit("SET_AUDIT_LOG", payload);
    },
    async approve({ state, getters }, id) {
      return await $http.post(`admin/audit-logs/${id}/approve`);
    },
    async approveAll({ state, getters }) {
      return await $http.post(`admin/audit-logs/approve-all`);
    },
    async reject({ state, getters }, id) {
      return await $http.post(`admin/audit-logs/${id}/reject`);
    },
  },
};
